import ProtectPlusImg from "@/assets/images/pro-plus-logo.webp";
import SolutionHowToReturnALargeItem from "./screens/SolutionHowToReturnALargeItem";
import SolutionBrandSupport from "./screens/SolutionBrandSupport";
import SolutionOther from "./screens/SolutionOther";
import SolutionUnwantedItem from "./screens/SolutionUnwantedItem";
import TrackReturnAndRefund from "./screens/TrackReturnAndRefund";
import SolutionCheckStatus from "./screens/SolutionCheckStatus";
import SolutionRefund from "./screens/SolutionRefund";
import SolutionDamagedOnDelivery from "./screens/SolutionDamagedOnDelivery";

export const OPTION_TYPES = {
  IMAGE_BUTTON: "IMAGE_BUTTON",
  SPACER: "SPACER",
  AGENT_FORCE_CHAT_BOT: "AGENT_FORCE_CHAT_BOT"
};

export const INFO_TYPES = {
  TOOLTIP_DETAILS: "TOOLTIP_DETAILS"
};

const notWanted = {
  title: "Where did you buy the item?",
  options: [
    {
      buttonLabel: "Online",
      nextPage: "online"
    },
    {
      buttonLabel: "In Store",
      nextPage: "jlShop"
    }
  ]
};

const faultyLarge = {
  title: "Faulty Item",
  esiContent: "/content-renderer/content/returnsandrefunds/faulty-item",
  viewContactDetails: "problemsWithProduct-other"
};

const returnsData = ({ showAgentForceChatButton }) => {
  return {
    returnsAndRefunds: {
      title: "Returns and refunds",
      optionsContainerClass: "alignCenter",
      getSolutionsForCurrentTag: true,
      options: [
        {
          buttonLabel: "Returning an item",
          nextPage: "returningAnItem"
        },
        {
          buttonLabel: "Check the status of a refund",
          nextPage: "checkStatusOfRefund"
        },
        {
          buttonLabel: "Information about our returns policy",
          nextPage: "informationOnOurReturnsPolicy"
        },
        {
          buttonLabel: "Exchanging an item",
          nextPage: "exchangingAnItem"
        },
        ...(showAgentForceChatButton ? [
          { optionType: OPTION_TYPES.SPACER }, 
          {
            optionType: OPTION_TYPES.AGENT_FORCE_CHAT_BOT
          }
        ] : []),
        {
          imageSrc: ProtectPlusImg.src,
          imageAlt: "Protect Plus",
          subTitle: "Refund information",
          className: "button--protectplus",
          url: "https://www.johnlewis.com/our-services/protect-plus"
        }
      ]
    },
    checkStatusOfRefund: {
      breadcrumbTitle: "Checking the status of a refund",
      solution: SolutionCheckStatus
    },
    refundJohnLewis: {
      title: "John Lewis and Partners",
      uptoLabel: "5 days",
      solution: SolutionRefund,
      esiContent: "/content-renderer/content/returnsandrefunds/refund-john-lewis",
      viewContactDetails: "returnsAndRefunds-refunds-refundsJL",
      showTimeline: false
    },
    refundWaitrose: {
      title: "Waitrose & Partners",
      uptoLabel: "2 weeks",
      solution: SolutionRefund,
      esiContent: "/content-renderer/content/returnsandrefunds/refund-waitrose",
      viewContactDetails: "returnsAndRefunds-refunds-refundsWaitrose-refundsWaitroseTwoWeeks",
      showTimeline: true
    },
    refundBoothsDobbies: {
      title: "Booths or Dobbies",
      uptoLabel: "2 weeks",
      solution: SolutionRefund,
      esiContent: "/content-renderer/content/returnsandrefunds/refund-coop-booths-and-shell",
      viewContactDetails: "returnsAndRefunds-refunds-refundsRoyalMail-refundsRoyalMailTwoWeeks",
      showTimeline: true
    },
    refundRoyalMailCollectPlusEvri: {
      title: "Royal Mail, Collect+ or Evri",
      uptoLabel: "2 weeks",
      solution: SolutionRefund,
      esiContent: "/content-renderer/content/returnsandrefunds/refund-royal-mail-collect-plus-evri",
      viewContactDetails: "returnsAndRefunds-refunds-refundsCollectPlus-refundsCollectPlusTwoWeeks",
      showTimeline: true
    },
    exchangingAnItem: {
      title: "What is your reason for exchanging the item?",
      options: [
        {
          buttonLabel: "I no longer want it",
          nextPage: "exchanges"
        },
        {
          buttonLabel: "It's a faulty electrical item",
          nextPage: "faultyLarge"
        },
        {
          buttonLabel: "Other",
          nextPage: "other"
        }
      ]
    },
    exchanges: {
      title: "Exchanges",
      esiContent: "/content-renderer/content/returnsandrefunds/exchanges",
      viewContactDetails: "returnsAndRefunds-returningOrExchanging"
    },
    returningAnItem: {
      title: "Returning an item",
      options: [
        {
          buttonLabel: "A small item",
          nextPage: "small"
        },
        {
          buttonLabel: "A large item",
          nextPage: "large"
        },
        {
          buttonLabel: "A gift",
          nextPage: "gift"
        },
        {
          buttonLabel: "Jewellery or a watch",
          nextPage: "jewellery"
        }
      ],
      information: [
        {
          informationType: INFO_TYPES.TOOLTIP_DETAILS,
          label: "What is a large item",
          details:
            "Delivered by a two-person delivery team e.g. furniture or electrical appliances, that would need to be collected"
        }
      ]
    },
    small: {
      title: "What is the reason for return?",
      options: [
        {
          buttonLabel: "I no longer want it",
          nextPage: "notWanted"
        },
        {
          buttonLabel: "Faulty electrical item",
          nextPage: "faulty"
        },
        {
          buttonLabel: "Damaged on delivery",
          nextPage: "damagedOnDelivery"
        },
        {
          buttonLabel: "Broken after use",
          url: "/email-us?t=problemsWithProduct-problemsOther"
        },
      ]
    },
    faulty: {
      title: "Did you buy the item in the last 30 days?",
      options: [
        {
          buttonLabel: "Yes",
          nextPage: "yes"
        },
        {
          buttonLabel: "No",
          nextPage: "no"
        }
      ]
    },
    yes: faultyLarge,
    no: {
      title: "What brand is the item?",
      options: [
        {
          buttonLabel: "Nespresso",
          nextPage: "nespresso"
        },
        {
          buttonLabel: "Dyson",
          nextPage: "dyson"
        },
        {
          buttonLabel: "Vax",
          nextPage: "vax"
        },
        {
          buttonLabel: "Fitbit",
          nextPage: "fitbit"
        },
        {
          buttonLabel: "Other",
          nextPage: "otherFaulty"
        }
      ]
    },
    otherFaulty: faultyLarge,
    nespresso: {
      title: "Product experts at Nespresso are on hand for the best technical support",
      esiContent: "/content-renderer/content/returnsandrefunds/brand-support---nespresso",
      brand: "Nespresso",
      solution: SolutionBrandSupport
    },
    dyson: {
      title: "Product experts at Dyson are on hand for the best technical support",
      esiContent: "/content-renderer/content/returnsandrefunds/brand-support---dyson",
      brand: "Dyson",
      solution: SolutionBrandSupport
    },
    vax: {
      title: "Product experts at VAX are on hand for the best technical support",
      esiContent: "/content-renderer/content/returnsandrefunds/brand-support---vax",
      brand: "VAX",
      solution: SolutionBrandSupport
    },
    fitbit: {
      title: "Product experts at Fitbit are on hand for the best technical support",
      esiContent: "/content-renderer/content/returnsandrefunds/brand-support---fitbit",
      brand: "Fitbit",
      solution: SolutionBrandSupport
    },
    notWanted,
    online: {
      breadcrumbTitle: "Returning an unwanted item",
      solution: SolutionUnwantedItem
    },
    jlShop: {
      title: "Returning an item to one of our John Lewis & Partner shops",
      esiContent: "/content-renderer/content/returnsandrefunds/returning-an-item-to-shop"
    },
    large: {
      title: "What is the reason for return?",
      options: [
        {
          buttonLabel: "I no longer want it",
          nextPage: "notWantedLarge"
        },
        {
          buttonLabel: "It's a faulty electrical item",
          nextPage: "faultyLarge"
        },
        {
          buttonLabel: "Other",
          nextPage: "other"
        }
      ]
    },
    notWantedLarge: {
      title: "Returning a large item",
      subTitle: "How to return",
      solution: SolutionHowToReturnALargeItem
    },
    faultyLarge,
    other: {
      title: "We're sorry there is a problem with your item",
      solution: SolutionOther
    },
    damagedOnDelivery: {
      solution: SolutionDamagedOnDelivery
    },
    gift: {
      title: "Returning a gift",
      esiContent: "/content-renderer/content/returnsandrefunds/returning-a-gift"
    },
    jewellery: {
      title: "How much did the Jewellery or watch cost?",
      options: [
        {
          buttonLabel: "£500 or more",
          nextPage: "over500"
        },
        {
          buttonLabel: "Less than £500",
          nextPage: "under500"
        }
      ]
    },
    over500: {
      title: "Returning jewellery or a watch with a value of £500 or more",
      esiContent: "/content-renderer/content/returnsandrefunds/returning-jewellery-or-watch-worth-more-than-500-pounds",
      viewContactDetails: "returnsAndRefunds-returningOrExchanging"
    },
    under500: notWanted,
    checkingTheStatusOfARefund: {
      title: "Checking the status of a refund"
    },
    informationOnOurReturnsPolicy: {
      title: "Returns Policy. Our customers terms & conditions",
      esiContent: "/content-renderer/content/returnsandrefunds/our-refund-policy"
    },
    whatWouldYouLikeToReturn: {
      title: "What would you like ro return?"
    },
    howWeWillRefundYou: {
      title: "How and when we refund you when you make a return",
      esiContent: "/content-renderer/content/returnsandrefunds/how-and-when-we-refund-you"
    },
    stockJewellery: {
      title: "John Lewis & Partners shops that stock jewellery",
      esiContent: "/content-renderer/content/returnsandrefunds/returning-jewellery-and-watches-to-store"
    },
    protectPlusRefundInformation: {
      imageSrc: ProtectPlusImg.src,
      title: "Refund information",
    },
    howToReturnYourItem: {
      esiContent: "/content-renderer/customer-services/returns/how-to-return-your-item"
    },
    trackReturnAndRefund: {
      breadcrumbTitle: "Customer Services",
      breadcrumbHref: "/",
      solution: TrackReturnAndRefund
    },
  };
};

export default returnsData;
